import React from 'react';
import { connect } from 'react-redux';
import { container } from '@Container';
import { TYPES } from '@Types';
import { MapsAction } from '@Redux/actions';
import { Dispatch } from '@Redux/type';
import { Col, Row } from 'reactstrap';
import Repeater from '@Utils/Repeater';
import { MapView } from '@Selectors/ninthage/view/map.view';
import { AppState } from '@Redux/store';
import { Link } from 'react-router-dom';

const MapPageIndex: React.FC<MapPageIndexProps> = ({ maps, load }) => {
  React.useEffect(() => {
    load();
  }, []);

  return (
    <>
      <h1 className="text-center">Maps</h1>
      <Row>
        <Repeater data={maps} indexPrefix="map">
          {(map: MapView) => (
            <Col xs={12} md={6} lg={4} className={'p-3'}>
              <Link to={`${map.id}`} className="text-decoration-none">
                {map.logo && (<img src={map.logo} alt={map.name} className={'img-fluid'} />)}
                <h2>{map.name}</h2>
                {map.description && (
                  <p>{map.description.substring(0, 250)}...</p>
                )}
              </Link>
            </Col>
          )}
        </Repeater>
      </Row>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  maps: (state.maps.entity ?? [])
    .map((map) => ({
      id: map.id,
      initials: map.initials,
      name: map.name,
      description: map.description,
      logo: map.logo,
      width: 0,
      height: 0,
      elements: [],
      terrains: [],
    } satisfies MapView as MapView))
    .sort((a, b) => a.name.localeCompare(b.name)),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const mapsAction = container.get<MapsAction>(TYPES.Actions.MapsAction);
  return {
    load: () => dispatch(mapsAction.fetchData()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MapPageIndex);

type MapPageIndexProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
